import request from '@/utils/request'

let StatisticsApi = {

  getUserStatic(data) {
    return request._post('/shop/statistics.sales/getUserStatistics', data);
  },
  getMonthlyUserTrend(data) {
    return request._post('/shop/statistics.sales/getMonthlyUserTrend', data);
  },
  getUserTypeDistribution(data) {
    return request._post('/shop/statistics.sales/getUserTypeDistribution', data);
  },
  getPurchaseRanking(data) {
    return request._post('/shop/statistics.sales/getPurchaseRanking', data);
  },
  getSalesInviteRanking(data) {
    return request._post('/shop/statistics.sales/getSalesInviteRanking', data);
  },
  getOrderStatisticsCards(data) {
    return request._post('/shop/statistics.sales/getOrderStatisticsCards', data);
  },
  getSalesTrendChart(data) {
    return request._post('/shop/statistics.sales/getSalesTrendChart', data);
  },

  
  getProductSalesRanking(data) {
    return request._post('/shop/statistics.sales/getProductSalesRanking', data);
  },
  getProductViewRanking(data) {
    return request._post('/shop/statistics.sales/getProductViewRanking', data);
  },
  getProductRefundRanking(data) {
    return request._post('/shop/statistics.sales/getProductRefundRanking', data);
  },





  getTotalPurchaseAmount(data) {
    return request._post('/shop/statistics.sales/getTotalPurchaseAmount', data);
  },
  getTotalOrderCount(data) {
    return request._post('/shop/statistics.sales/getTotalOrderCount', data);
  },
  getCooperationSuppliers(data) {
    return request._post('/shop/statistics.sales/getCooperationSuppliers', data);
  },

  getAverageOrderPrice(data) {
    return request._post('/shop/statistics.sales/getAverageOrderPrice', data);
  },

  getPurchaseTrend(data) {
    return request._post('/shop/statistics.sales/getPurchaseTrend', data);
  },
  getPurchaseRecords(data) {
    return request._post('/shop/statistics.sales/getPurchaseRecords', data);
  },

  getProductList(data) {
    return request._post('/shop/statistics.sales/getProductList', data);
  },
  getSalesOverview(data) {
    return request._post('/shop/statistics.sales/getSalesOverview', data);
  },
  getSalesTrend(data) {
    return request._post('/shop/statistics.sales/getSalesTrend', data);
  },
  getSalesDetail(data) {
    return request._post('/shop/statistics.sales/getSalesDetail', data);
  },



  getTodayDeliveryStats(data) {
    return request._post('/shop/statistics.sales/getTodayDeliveryStats', data);
  },
  getDeliveryTrendChart(data) {
    return request._post('/shop/statistics.sales/getDeliveryTrendChart', data);
  },
  getDeliveryList(data) {
    return request._post('/shop/statistics.sales/getDeliveryList', data);
  },



  getCoreMetrics(data) {
    return request._post('/shop/statistics.sales/getCoreMetrics', data);
  },
  getOrderTrend(data) {
    return request._post('/shop/statistics.sales/getOrderTrend', data);
  },
  getTopProducts(data) {
    return request._post('/shop/statistics.sales/getTopProducts', data);
  },
  getOrderStatusDistribution(data) {
    return request._post('/shop/statistics.sales/getOrderStatusDistribution', data);
  },
  getOrderList(data) {
    return request._post('/shop/statistics.sales/getOrderList', data);
  },





  getOrderStatisticss(data) {
    return request._post('/shop/statistics.sales/getOrderStatisticss', data);
  },
  getOrderTrends(data) {
    return request._post('/shop/statistics.sales/getOrderTrends', data);
  },
  getProductCategoryDistribution(data) {
    return request._post('/shop/statistics.sales/getProductCategoryDistribution', data);
  },
  getOrderLists(data) {
    return request._post('/shop/statistics.sales/getOrderLists', data);
  },





  getInventoryOverview(data) {
    return request._post('/shop/statistics.sales/getInventoryOverview', data);
  },
  getInventoryTrendAnalysis(data) {
    return request._post('/shop/statistics.sales/getInventoryTrendAnalysis', data);
  },
  getInventoryList(data) {
    return request._post('/shop/statistics.sales/getInventoryList', data);
  },
  exportInventory(data) {
    return request._post('/shop/statistics.sales/exportInventory', data);
  },







  /*订单数据统计*/
  getOrderTotal(data) {
    return request._post('/shop/statistics.sales/index', data);
  },
  /*订单时间段统计*/
  getOrderByDate(data) {
    return request._post('/shop/statistics.sales/order', data);
  },
  /*商品时间段统计*/
  getProductByDate(data) {
    return request._post('/shop/statistics.sales/product', data);
  },
  /*会员数据统计*/
  getUserTotal(data) {
    return request._post('/shop/statistics.user/index', data);
  },
  /*成交占比*/
  getUserScale(data) {
    return request._post('/shop/statistics.user/scale', data);
  },
  /*新增会员*/
  getNewUser(data) {
    return request._post('/shop/statistics.user/new_user', data);
  },
  /*成交会员数*/
  getPayUser(data) {
    return request._post('/shop/statistics.user/pay_user', data);
  },
  getProductSales(data) {
    return request._post('/shop/statistics.productsales/index', data);
  },
  getsupplySales(data) {
    return request._post('/shop/statistics.productsales/supplysales', data);
  },
  getSSales(data) {
    return request._post('/shop/statistics.productsales/getSSales', data);
  },
  getDriverSales(data) {
    return request._post('/shop/statistics.productsales/getDriverSales', data);
  },
  getSalesStore(data){
    return request._post('/shop/statistics.productsales/getSalesStore', data);
  },
  //获取供应商货款
  getSupplyMoney(data) {
    return request._post('/shop/statistics.supplyMoney/index', data);
  },
  //获取佣金src\views\statistics\usercommission\index.vue
  getUserCommission(data) {
    return request._post('/shop/statistics.userCommission/index', data);
  },
//获取各个阶段的业绩统计 
getAchievement(data) {
  return request._post('/shop/statistics.achievement/achievement', data);
},
//获取各个阶段的订单统计 
getOrder(data) {
  return request._post('/shop/statistics.order/order', data);
},


}

export default StatisticsApi;



// WEBPACK FOOTER //
// ./src/api/statistics.js